var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:done"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.05 18L4.34998 12.3L5.77498 10.875L10.05 15.15L19.225 5.97501L20.65 7.40001L10.05 18Z",
    fill: "#4555BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsDone);
export default __webpack_public_path__ + "static/media/material-symbols_done.272382b9af68996791d53a5c8772ac2b.svg";
export { ForwardRef as ReactComponent };